import { styled } from '@mui/material';

export const Reviews = styled('section')(() => ({
  position: 'relative',
  width: '100%',
}));

export const CarouselWrap = styled('div')(() => ({
  width: '100%',
}));

export const Card = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '20px',
  height: '100%',
  padding: '44px',
  borderRadius: '24px',
  textAlign: 'left',
  backgroundColor: theme.palette.color.global.card,
  transition: 'background-color var(--transition-ease-default)',

  '&:hover': {
    backgroundColor: theme.palette.color.surface.modalTetriaryHover,
  },

  [theme.breakpoints.down('2xl')]: {
    padding: '32px',
  },
  [theme.breakpoints.down('lg')]: {
    padding: '24px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '16px',
    padding: '20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '16px',
  },
}));

export const CardHeader = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  gap: '4px',
  textAlign: 'left',
}));

export const Stars = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
}));

export const Star = styled('img')(() => ({
  width: '20px',
  height: '20px',
  flexShrink: 0,
}));
